// extracted by mini-css-extract-plugin
export default {"container":"container__v+HPg","grid":"grid__LdnOj","card":"card__nYtp8","text":"text__avuUE"};